import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import EventsCoupon from 'modules/events-coupon/index.js';

const { IntentActionTrigger } = MojitoPresentation.Base.Intent;
const { NavigationPathBuilder } = MojitoPresentation.Base.Navigation;
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;

export default class CmsSportCouponView extends UIViewImplementation {
    constructor(props) {
        super(props);
        this.onEventListItemClicked = eventId =>
            IntentActionTrigger.showSportEvent(this.props.sportId, eventId);
        this.getHrefItem = eventId =>
            NavigationPathBuilder.sportEventPath(
                this.props.sportId,
                eventId,
                this.appContext().routeResolver
            );
        this.onChildLoaded = this.onChildLoaded.bind(this);
    }

    onChildLoaded(eventGroupsId) {
        this.props.onDataLoad(eventGroupsId);
    }

    render() {
        const { sportId, couponId, couponName } = this.props;
        return (
            <div className="CmsSportCouponView ta-CmsSportCouponView">
                <EventsCoupon
                    sportId={sportId}
                    eventGroupsId={couponId}
                    headerText={couponName}
                    config={this.config.eventCoupon}
                    analyticsName={couponName}
                    onDataLoad={this.onChildLoaded}
                    isCouponNavigation={true}
                />
            </div>
        );
    }
}
